import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { MarketingAnalyticsPhoneNumberInput } from '@/models/marketing';

export const createMarketingAnalyticsPhoneNumber = async (data: MarketingAnalyticsPhoneNumberInput): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateMarketingAnalyticsPhoneNumber($data: MarketingAnalyticsPhoneNumberInputType!) {
        createMarketingAnalyticsPhoneNumber(data: $data) {
          phoneNumber
          description
          media
          platform
          existingCampaign
          notExistingCampaign
          regSource
          isActive
        }
      }
    `),
    variables: {
      data,
    },
  });

  return !!response.data?.createMarketingAnalyticsPhoneNumber;
};
